module.exports = __webpack_public_path__ + "static/media/payment-history-white.64be8f68.svg";